import Auth from "@aws-amplify/auth";

export async function Init(): Promise<void> {
  const config = {
    stage: "beta",
    aws_cognito_region: "ap-southeast-2",
    aws_cognito_identity_pool_id: "ap-southeast-2:ecdbf61b-750b-4b6a-8e09-7f831532985c",
    aws_user_pools_id: "ap-southeast-2_siM647N5d",
    aws_user_pools_web_client_id: "6rvbp6ekhnj4t46tn1dhfffo2j",
    Auth: {
      identityPoolId: "ap-southeast-2:ecdbf61b-750b-4b6a-8e09-7f831532985c",
      region: "ap-southeast-2",
      userPoolId: "ap-southeast-2_siM647N5d",
      userPoolWebClientId: "6rvbp6ekhnj4t46tn1dhfffo2j",
    },
    oauth: {
      domain: `whs-safer-beta-jp.auth.us-east-1.amazoncognito.com`,
      redirectSignIn: "https://beta.jp.safer.whs.amazon.dev",
      redirectSignOut: "https://beta.jp.safer.whs.amazon.dev",
      scope: ["openid", "profile"],
      responseType: "code",
    },
  };
  Auth.configure(config);
}
